module.exports = __webpack_public_path__ + "static/media/cerdo_big.ad8be9ba.png";